import { IMetaDataState } from './types';

export const selectRolesLoadedState = (state: IMetaDataState) => state.loadedRoles;
export const selectRoles = (state: IMetaDataState) => state.roles;
export const selectTenderTypes = (state: IMetaDataState) => state.tenderTypes;
export const selectTenderValidators = (state: IMetaDataState) => state.tenderValidators;
export const selectTouchPointGroups = (state: IMetaDataState) => state.touchPointGroups;
export const selectTouchPointGroupsLoaded = (state: IMetaDataState) => state.touchPointGroupsLoaded;
export const selectTouchPointGroupsSyncing = (state: IMetaDataState) =>
  state.touchPointGroupsSyncing;
export const selectTouchPointGroupsError = (state: IMetaDataState) => state.touchPointGroupsError;
